import { Modal, TreatyClaimShareView } from "components";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { useTreatyClaimShare } from "hooks/data/use-treaty-claims";
import { useAppLocation } from "_graphql/cache/auth";

export default function ViewTreatyClaimShareContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const { params } = useAppLocation();
  const searchParams = useSearch<LocationGenerics>();
  const { loading, share } = useTreatyClaimShare({
    treatyClaimId: params?.claim || "",
    participantId: searchParams?.id || "",
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      // hideActions
      // size="6xl"
      title="View Treaty Claim Share"
      description="View Treaty Claim share"
    >
      <TreatyClaimShareView share={share} />
    </Modal>
  );
}
